import React, { Fragment, FunctionComponent } from 'react';
import { Translatable } from 'types/translatable';
import { useTranslator } from 'hooks/useTranslator';

export const Summary: FunctionComponent<{ summary: Translatable }> = ({ summary }) => {
    const translator = useTranslator();

    return (
        <>
            {(translator(summary)?.split('\n') as string[] | undefined)?.map((item, index) => {
                return (
                    <Fragment key={item}>
                        {index > 0 ? <br /> : null}
                        {item}
                    </Fragment>
                );
            })}
        </>
    );
};
